import { useRef, useState, useContext } from "react";
import { IoIosClose } from "react-icons/io";
import "./MarketingCampaignNewForm.scss";
import { createMarketingCampaign } from "../../api/marketingCampaigns.api";
import EmailEditor from "react-email-editor";
import defaultTemplate from "./defaultTemplate.json";
import { UserContext } from "../Context/AuthUser";

const MarketingCampaignNewForm = ({
  setOpenNewMarketingCampaign,
  marketingsCampaigns,
}) => {
  const emailEditorRef = useRef(null);

  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState(false);
  const { user } = useContext(UserContext);

  const onLoad = () => {
    if (emailEditorRef.current && defaultTemplate.design) {
      let designString = JSON.stringify(defaultTemplate.design);

      const nombre = user?.fullName || "Tu Nombre";
      const profesion = user?.position || "Tu Profesión";
      const telefono = user?.consultantMobileNumber || "Tu Teléfono";
      const email = user?.consultantEmail || "tu@email.com";

      const direccion =
        user?.offices && user.offices.length > 0
          ? user.offices[0]
          : "Tu Dirección";

      designString = designString.replace(/{{nombreConsultor}}/g, nombre);
      designString = designString.replace(/{{profesionConsultor}}/g, profesion);
      designString = designString.replace(/{{telefonoConsultor}}/g, telefono);
      designString = designString.replace(/{{emailConsultor}}/g, email);
      designString = designString.replace(/{{direccionConsultor}}/g, direccion);

      const finalDesign = JSON.parse(designString);

      emailEditorRef.current.editor.loadDesign(finalDesign);
    }
  };

  const handleSaveDesign = async (e) => {
    e.preventDefault();

    if (title.trim() === "") {
      setTitleError(true);
      return;
    }

    emailEditorRef.current.editor.exportHtml(async (data) => {
      const { design, html } = data;

      const payload = {
        title: title,
        htmlBody: html,
        design: design,
      };

      try {
        const createCampaign = await createMarketingCampaign(payload);
        if (Object.keys(createCampaign).includes("_id")) {
          marketingsCampaigns.unshift(createCampaign);
          setOpenNewMarketingCampaign(false);
        }
      } catch (error) {
        console.error("Error al crear la campaña:", error);
        alert("Hubo un error al guardar la plantilla");
      }
    });
  };

  return (
    <div className="MarketingCampaignNewForm">
      <div className="MarketingCampaignNewForm__title">
        <h1>Diseñar Plantilla de Campaña</h1>
        <IoIosClose
          className="MarketingCampaignNewForm__title__close"
          onClick={() => setOpenNewMarketingCampaign(false)}
        />
      </div>

      <div
        className="MarketingCampaignNewForm__item"
        style={{ padding: "0 20px", marginBottom: "15px" }}
      >
        <label
          htmlFor="customTitle"
          style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}
        >
          Nombre de la plantilla
        </label>
        <input
          id="customTitle"
          type="text"
          className="yearInput"
          placeholder="Ej: Campaña de Navidad..."
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            setTitleError(false);
          }}
          style={{
            width: "50%",
            padding: "10px",
            borderRadius: "4px",
            border: titleError ? "1px solid red" : "1px solid #ccc",
          }}
        />
        {titleError && (
          <p
            className="error"
            style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
          >
            *Por favor, dale un nombre a tu plantilla para poder identificarla.
          </p>
        )}
      </div>

      <div style={{ width: "100%", height: "75vh" }}>
        <EmailEditor
          ref={emailEditorRef}
          height="60vh"
          style={{ width: "100%", height: "500px" }}
          onLoad={onLoad}
        />
      </div>

      <div
        className="MarketingCampaignNewForm__buttons"
        style={{ marginTop: "15px", padding: "0 20px" }}
      >
        <button
          type="button"
          className="subHeader__btn"
          onClick={handleSaveDesign}
        >
          Guardar Plantilla
        </button>
        <button
          type="button"
          className="buttonFormCancel"
          onClick={() => setOpenNewMarketingCampaign(false)}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default MarketingCampaignNewForm;
